// Version : 0.0.1
// Author : VISHAL BHARATHI
// LastEdit : VISHAL BHARATHI
// Last ADD : COMMENT LINES ADDED, PAYLOAD VALUES INITIALISED
// MODFIED DATA : 04-08-2025

import { takeLatest, put, all, call } from 'redux-saga/effects';

import questionnaireTypes from './questionaire.types';

import {
	questionnaireListGet,
	questionnaireDelete,
	questionDelete,
	questionnaireDetailsAdd,
	questionnaireDetailsFetch,
	questionnaireUpdate,
	moduleListFetch,
} from './questionaire.service';

import {
	// GET QUESTIONNAIRE LIST
	getQuestionnaireSuccess,
	getQuestionnaireFailure,
	getQuestionnaireResponseChanged,
	// DELETE QUESTIONNAIRE
	deleteQuestionnaireSuccess,
	deleteQuestionnaireFailure,
	deleteQuestionnaireResponseChanged,
	// DELETE QUESTION
	deleteQuestionSuccess,
	deleteQuestionFailure,
	deleteQuestionResponseChanged,
	// ADD QUESTIONNAIRE
	addQuestionnaireSuccess,
	addQuestionnaireFailure,
	addQuestionnaireResponseChanged,
	// FETCH QUESTIONNAIRE DETAILS
	fetchQuestionnaireSuccess,
	fetchQuestionnaireFailure,
	fetchQuestionnaireResponseChanged,
	// UPDATE QUESTIONNAIRE
	updateQuestionnaireSuccess,
	updateQuestionnaireFailure,
	updateQuestionnaireResponseChanged,
	// GET MODULE LIST
	fetchModuleListSuccess,
	fetchModuleListFailure,
	fetchModuleListChanged,
} from './questionaire.action';

import { encryptData } from '../../_common/enode-decode';

import AlertManager from '../../../utils/alertManager';
/**   ******************* GET QUESTIONNAIRE START *************** */
export function* questionnaireGet({ payload }: any) {
	try {
		const key = 'GetAllQuestionnaireListkey';
		const { databaseName, companyID, limit, inputSearch } = payload;
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			Limit: limit,
			SearchData: inputSearch,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(questionnaireListGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getQuestionnaireFailure(responseData.data));
		} else {
			yield put(getQuestionnaireSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getQuestionnaireFailure(error));
	}
}

export function* resetGetQuestionnaireResponse() {
	yield put(getQuestionnaireResponseChanged());
}

export function* onGetQuestionnaire() {
	yield takeLatest(questionnaireTypes.GET_QUESTIONNAIRE_START, questionnaireGet);
}

export function* onGetQuestionnaireResponseReset() {
	yield takeLatest(
		questionnaireTypes.GET_QUESTIONNAIRE_RESPONSE_RESET,
		resetGetQuestionnaireResponse,
	);
}

/**   ******************* GET QUESTIONNAIRE END *************** */

/**   ******************* DELETE QUESTIONNAIRE START *************** */
export function* questionnaireListDelete({ payload }: any) {
	try {
		const key = 'DeleteQuestionnaireKey';
		const { databaseName, companyID, questionnaireID } = payload;
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			QuestionnaireID: questionnaireID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(questionnaireDelete, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(deleteQuestionnaireFailure(responseData.data));
		} else {
			yield put(deleteQuestionnaireSuccess(responseData.data));
		}
	} catch (error) {
		yield put(deleteQuestionnaireFailure(error));
	}
}

export function* resetDeleteQuestionnaireResponse() {
	yield put(deleteQuestionnaireResponseChanged());
}

export function* onDeleteQuestionnaire() {
	yield takeLatest(questionnaireTypes.DELETE_QUESTIONNAIRE_START, questionnaireListDelete);
}

export function* onDeleteQuestionnaireResponseReset() {
	yield takeLatest(
		questionnaireTypes.DELETE_QUESTIONNAIRE_RESPONSE_RESET,
		resetDeleteQuestionnaireResponse,
	);
}

/**   ******************* DELETE QUESTIONNAIRE END *************** */

/**   ******************* DELETE QUESTION START *************** */
export function* questionGet({ payload }: any) {
	try {
		const key = 'DeleteQuestionKey';
		const { databaseName, questionID } = payload;
		const jsonData = {
			DatabaseName: databaseName,
			QuestionID: questionID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(questionDelete, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(deleteQuestionFailure(responseData.data));
		} else {
			yield put(deleteQuestionSuccess(responseData.data));
		}
	} catch (error) {
		yield put(deleteQuestionFailure(error));
	}
}

export function* resetGetQuestionResponse() {
	yield put(deleteQuestionResponseChanged());
}

export function* onDeleteQuestion() {
	yield takeLatest(questionnaireTypes.DELETE_QUESTION_START, questionGet);
}

export function* onDeleteQuestionResponseReset() {
	yield takeLatest(questionnaireTypes.DELETE_QUESTION_RESPONSE_RESET, resetGetQuestionResponse);
}
/**   ******************* DELETE QUESTION END *************** */

/**   ******************* FETCH MODULE LIST START *************** */
export function* fetchModuleList({ payload }: any) {
	try {
		const key = 'ModuleListFetchKey';
		const { userID, databaseName, companyID } = payload;
		const jsonData = {
			UserID: userID,
			CompanyID: companyID,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(moduleListFetch, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchModuleListFailure(responseData.data));
		} else {
			yield put(fetchModuleListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchModuleListFailure(error));
	}
}

export function* resetFetchModuleListResponse() {
	yield put(fetchModuleListChanged());
}

export function* onFetchModuleList() {
	yield takeLatest(questionnaireTypes.FETCH_MODULE_LIST_START, fetchModuleList);
}

export function* onFetchModuleListResponseReset() {
	yield takeLatest(questionnaireTypes.FETCH_MODULE_LIST_RESET, resetFetchModuleListResponse);
}
/**   ******************* FETCH MODULE LIST END *************** */

/**   ******************* ADD QUESTIONNAIRE START *************** */
export function* addquestionnaire({ payload }: any) {
	try {
		const key = 'QuestionnaireCreateAddKey';
		const {
			databaseName,
			companyID,
			userID,
			questionnaireTitle,
			questionnaireDescriptionDetails,
			auditType,
			isPreQuestion,
			isPostQuestion,
			questionnaireQuestions,
		} = payload;
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			UserID: userID,
			Title: questionnaireTitle,
			Description: questionnaireDescriptionDetails,
			AuditType: auditType,
			IsPreQuestion: isPreQuestion ? 1 : 0,
			IsPostQuestion: isPostQuestion ? 1 : 0,
			QuestionArr: JSON.stringify(questionnaireQuestions).replace(/"/g, "'"),
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(questionnaireDetailsAdd, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(addQuestionnaireFailure(responseData.data));
		} else {
			yield put(addQuestionnaireSuccess(responseData.data));
		}
	} catch (error) {
		yield put(addQuestionnaireFailure(error));
	}
}

export function* resetAddQuestionnaireResponseChanged() {
	yield put(addQuestionnaireResponseChanged());
}

export function* onAddQuestionnaire() {
	yield takeLatest(questionnaireTypes.ADD_QUESTIONNAIRE_START, addquestionnaire);
}

export function* onAddQuestionnaireResponseReset() {
	yield takeLatest(
		questionnaireTypes.ADD_QUESTIONNAIRE_RESPONSE_RESET,
		resetAddQuestionnaireResponseChanged,
	);
}
/**   ******************* ADD QUESTIONNAIRE END *************** */

/**   ******************* FETCH QUESTIONNAIRE START *************** */
export function* fetchquestionnaire({ payload }: any) {
	try {
		const key = 'FetchQuestionnaireListkey';
		const { databaseName, companyID, userID, questionnaireID } = payload;
		const jsonData = {
			UserID: userID,
			CompanyID: companyID,
			QuestionnaireID: questionnaireID,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(questionnaireDetailsFetch, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchQuestionnaireFailure(responseData.data));
		} else {
			yield put(fetchQuestionnaireSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchQuestionnaireFailure(error));
	}
}

export function* resetFetchQuestionnaireResponse() {
	yield put(fetchQuestionnaireResponseChanged());
}

export function* onFetchQuestionnaire() {
	yield takeLatest(questionnaireTypes.FETCH_QUESTIONNAIRE_START, fetchquestionnaire);
}

export function* onFetchQuestionnaireResponseReset() {
	yield takeLatest(
		questionnaireTypes.FETCH_QUESTIONNAIRE_RESPONSE_RESET,
		resetFetchQuestionnaireResponse,
	);
}
/**   ******************* FETCH QUESTIONNAIRE END *************** */

/**   ******************* UPDATE QUESTIONNAIRE START *************** */
export function* updatequestionnaire({ payload }: any) {
	try {
		const key = 'QuestionnaireUpdateKey';
		const {
			databaseName,
			companyID,
			userID,
			questionnaireID,
			questionnaireTitle,
			questionnaireDescriptionDetails,
			auditType,
			isPreQuestion,
			isPostQuestion,
			questionnaireQuestions,
		} = payload;
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			UserID: userID,
			QuestionnaireID: questionnaireID,
			Title: questionnaireTitle,
			Description: questionnaireDescriptionDetails,
			AuditType: auditType,
			IsPreQuestion: isPreQuestion ? 1 : 0,
			IsPostQuestion: isPostQuestion ? 1 : 0,
			QuestionArr: JSON.stringify(questionnaireQuestions).replace(/"/g, "'"),
		};
		console.log('jsonData -> ', jsonData);
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(questionnaireUpdate, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateQuestionnaireFailure(responseData.data));
		} else {
			yield put(updateQuestionnaireSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateQuestionnaireFailure(error));
	}
}

export function* resetUpdateQuestionnaireResponse() {
	yield put(updateQuestionnaireResponseChanged());
}

export function* onUpdateQuestionnaire() {
	yield takeLatest(questionnaireTypes.UPDATE_QUESTIONNAIRE_START, updatequestionnaire);
}

export function* onUpdateQuestionnaireResponseReset() {
	yield takeLatest(
		questionnaireTypes.UPDATE_QUESTIONNAIRE_RESPONSE_RESET,
		resetUpdateQuestionnaireResponse,
	);
}
/**   ******************* UPDATE QUESTIONNAIRE END *************** */

export function* questionnaireSaga() {
	yield all([
		call(onGetQuestionnaire),
		call(onGetQuestionnaireResponseReset),
		call(onDeleteQuestionnaire),
		call(onDeleteQuestionnaireResponseReset),
		call(onDeleteQuestion),
		call(onDeleteQuestionResponseReset),
		call(onAddQuestionnaire),
		call(onAddQuestionnaireResponseReset),
		call(onFetchQuestionnaire),
		call(onFetchQuestionnaireResponseReset),
		call(onUpdateQuestionnaire),
		call(onUpdateQuestionnaireResponseReset),
		call(onFetchModuleList),
		call(onFetchModuleListResponseReset),
	]);
}
